// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import { cachedEndpointCall } from '../../services/cached-endpoint/index.tsx';
import {
	trackPersonalisation,
	fetchOnboardingPersonalisationWithRethrow,
} from '../../services/onboarding-personalisation/index.tsx';
import type { FetchOnboardingPersonalisationArgs } from '../../services/onboarding-personalisation/types.tsx';
import type { OnboardingPersonalisationState } from './types.tsx';

const fetchOnboardingPersonalisation = cachedEndpointCall(
	(args: FetchOnboardingPersonalisationArgs) => fetchOnboardingPersonalisationWithRethrow(args),
);

const trackPersonalisationAction =
	({
		additionalParameters,
	}: FetchOnboardingPersonalisationArgs): Action<OnboardingPersonalisationState> =>
	() =>
		trackPersonalisation({ additionalParameters });

export const actions = {
	fetchOnboardingPersonalisation,
	trackPersonalisation: trackPersonalisationAction,
};
